import '@fontsource-variable/inter';
import '@fontsource/tinos/400.css';
import '@fontsource/tinos/400-italic.css';
import '@fontsource/tinos/700.css';
import { mount } from 'svelte';
import './app.css';
import App from './App.svelte';
import { initTelegram } from './lib/telegram';

// На обычном сайте ничего не делает; в Telegram (tg.html) — тема мессенджера и полноэкранный режим.
initTelegram();
mount(App, { target: document.getElementById('app')! });
